/**
 * Mark-as-paid must write the full Firestore invoice.
 * The list page only holds summary rows (no line items).
 */
export const INVOICE_LIST_FIRST_PAGE = 80;
export const INVOICE_LIST_NEXT_PAGE = 500;

export function buildPaidInvoiceUpdate(current, invoiceId, timestamp) {
  if (!invoiceId) {
    throw new Error("Invoice id is missing; cannot mark as paid.");
  }
  if (!current) {
    throw new Error("Invoice was not found; cannot mark as paid.");
  }
  if (current.status === "PAID") {
    throw new Error("This invoice has already been paid or marked as paid.");
  }

  return {
    ...current,
    _id: invoiceId,
    id: invoiceId,
    timestamp,
    status: "PAID",
    manuallyMarkedAsPaid: true,
    paymentPerformedTimestamp: timestamp
  };
}
